<template>
  <div class="container min-vh-100 d-flex align-items-center justify-content-center">
    <div class="card shadow-sm w-100" style="max-width: 400px; border-radius: 18px;">
      <div class="card-body d-flex flex-column align-items-center p-4">
        <img alt="logo" class="mb-3 rounded logo" src="@/assets/image.png" />
        <h2 class="h5 fw-bold text-center mb-3">Buka di Aplikasi "Hai Parahita"</h2>
        <div class="middle-card border w-100 mb-3 py-3 px-2 d-flex flex-column align-items-center">
          <p class="mb-0 text-center fw-400 color-neutral-600">Klik tombol di bawah untuk melanjutkan login di aplikasi Hai Parahita</p>
        </div>
        <div class="fw-400 fs-12 color-neutral-600 mb-2 text-center">Powered by Parahita</div>
        <a
          :href="intentLink"
          class="btn btn-primary w-100 mb-2 rounded-pill fw-semibold"
        >Buka di Aplikasi</a>
        <button
          class="btn btn-outline-secondary w-100 rounded-pill fw-semibold"
          :disabled="loading"
          @click="$emit('loginBrowser')"
        >{{ loading ? 'Memproses...' : 'Lanjutkan di Browser' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['loginBrowser'],
  setup () {
    const route = useRoute()

    const intentLink = computed(() => {
      const token = route.params.token
      const fallbackUrl = encodeURIComponent(`https://app.labparahita.com/haiparahitalogin/${token}?web=1`)
      return `intent://haiparahitalogin/${token}#Intent;scheme=haiparahita;package=com.parahita.android;S.browser_fallback_url=${fallbackUrl};end`
    })

    return {
      intentLink
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
  width: 200px;
  object-fit: contain;
}
.middle-card {
  border-radius: 12px;
}
</style>
